import { Box, Flex, Text } from "@chakra-ui/react"
import Icon from "components/UI/atoms/Icon"
import { useUI } from "providers/UIProvider"

const MapButton = ({ onClick }: any) => {
  const { T } = useUI()
  return (
    <Box
      as="button"
      bg="white"
      borderRadius="15px"
      fontSize="s"
      color="button_grey_bg"
      boxShadow="map_button_shadow"
      padding="7px 12px"
      onClick={onClick}
    >
      <Flex>
        <Icon name="location" iconStyles={{ fill: "#046CEC" }} />
        <Text ml="5px">{T("laundry.form.address_add_marker")}</Text>
      </Flex>
    </Box>
  )
}

export default MapButton